module.exports = __webpack_public_path__ + "static/downloable/guia-vales-agora.48d894a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/guias/guia-vales-agora.pdf
// module id = BY7u
// module chunks = 1